import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach the admin session header to every /admin request when logged in
api.interceptors.request.use((config) => {
  const path = config.url || "";
  if (path.includes("/admin/") && !path.endsWith("/admin/login")) {
    const sid = sessionStorage.getItem("dh_admin_session");
    if (sid) config.headers["X-Admin-Session"] = sid;
  }
  return config;
});

// ---------- Public ----------
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
export const listBlog = () => api.get("/blog").then((r) => r.data);
export const getBlog = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const listLogos = (kind) => api.get("/logos", { params: kind ? { kind } : {} }).then((r) => r.data);
export const listCities = () => api.get("/cities").then((r) => r.data);
export const getCity = (slug) => api.get(`/cities/${slug}`).then((r) => r.data);

// ---------- Admin: cities ----------
export const adminListCities = () => api.get("/admin/cities").then((r) => r.data);
export const adminCreateCity = (data) => api.post("/admin/cities", data).then((r) => r.data);
export const adminUpdateCity = (id, data) => api.patch(`/admin/cities/${id}`, data).then((r) => r.data);
export const adminDeleteCity = (id) => api.delete(`/admin/cities/${id}`).then((r) => r.data);

// ---------- Admin session ----------
export const adminLogin = (token) => api.post("/admin/login", { token }).then((r) => r.data);
export const adminGoogleSession = (session_id) => api.post("/admin/google-session", { session_id }).then((r) => r.data);
export const adminLogout = () => api.post("/admin/logout").then((r) => r.data);
export const adminVerify = () => api.post("/admin/verify").then((r) => r.data);

// ---------- Admin: contact submissions ----------
export const adminList = () => api.get("/admin/contact").then((r) => r.data);
export const adminUpdate = (id, status) => api.patch(`/admin/contact/${id}`, { status }).then((r) => r.data);
export const adminDelete = (id) => api.delete(`/admin/contact/${id}`).then((r) => r.data);

// ---------- Admin: logos ----------
export const adminCreateLogo = (data) => api.post("/admin/logos", data).then((r) => r.data);
export const adminUpdateLogo = (id, data) => api.patch(`/admin/logos/${id}`, data).then((r) => r.data);
export const adminDeleteLogo = (id) => api.delete(`/admin/logos/${id}`).then((r) => r.data);

// ---------- Admin: site content ----------
export const adminUpdateSite = (data) => api.patch("/admin/site", data).then((r) => r.data);

// ---------- Admin: blog ----------
export const adminListBlog = () => api.get("/admin/blog").then((r) => r.data);
export const adminCreateBlog = (data) => api.post("/admin/blog", data).then((r) => r.data);
export const adminUpdateBlog = (id, data) => api.patch(`/admin/blog/${id}`, data).then((r) => r.data);
export const adminDeleteBlog = (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data);

